import { deleteRequest, getRequest, postRequest, putRequest } from '.'
import type OccupancyStatus from 'app/frontend/types/custom/OccupancyStatus'
import { OccupancyData } from '../pages/TeamDashboard/subpages/TeamHousing/utils'

export type NeighborhoodOccupantPayload = {
  map_id: number
  plot_id?: string | number
  ranked_choice: number
  shard_index?: number
  character_id?: number
  user_id?: number
  note?: string
}

export type NeighborhoodOccupantUpdatePayload = {
  status?: OccupancyStatus
  note?: string
}

export const getNeighborhoodOccupants = async (
  guildId: number,
): Promise<OccupancyData> => {
  return await getRequest(`/api/guilds/${guildId}/neighborhoods`)
}

export const createNeighborhoodOccupant = async (
  guildId: number,
  payload: NeighborhoodOccupantPayload,
): Promise<OccupancyData> => {
  return await postRequest(`/api/guilds/${guildId}/neighborhoods`, payload)
}

export const updateNeighborhoodOccupant = async (
  guildId: number,
  occupantId: number,
  payload: NeighborhoodOccupantUpdatePayload,
): Promise<OccupancyData> => {
  return await putRequest(
    `/api/guilds/${guildId}/neighborhoods/${occupantId}`,
    payload,
  )
}

export const deleteNeighborhoodOccupant = async (
  guildId: number,
  rankedChoice: number,
  params: Pick<
    NeighborhoodOccupantPayload,
    'map_id' | 'character_id' | 'user_id'
  >,
): Promise<OccupancyData> => {
  const searchParams = new URLSearchParams()
  searchParams.set('map_id', params.map_id.toString())
  if (params.character_id)
    searchParams.set('character_id', params.character_id.toString())
  if (params.user_id) searchParams.set('user_id', params.user_id.toString())

  return await deleteRequest(
    `/api/guilds/${guildId}/neighborhoods/${rankedChoice}?${searchParams.toString()}`,
  )
}
